import React from 'react';

import { SvgAdminRole, SvgCustomRole, SvgUserRole } from 'components/SvgIcon';

export const getRoleIcon = role => {
  switch (true) {
    case !role.user_defined:
      if (role.role_type === 'SUPER_ADMIN') {
        return <SvgAdminRole />;
      }

      return <SvgUserRole />;
    default:
      return <SvgCustomRole />;
  }
};

export const numOfUsers = total => {
  return `Assigned to ${total} user${total > 1 ? 's' : ''}`;
};
